import {RootStore} from '../../stores/RootStore';
import {IPaymentMethodsBannerProps} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/wixcode/payments/getPaymentMethodsBannerProps';

export const getCashierBannerProps = (rootStore: RootStore): IPaymentMethodsBannerProps => {
  return rootStore.ecomPublicApi.payments.getPaymentMethodsBannerProps({
    productId: rootStore.$state.product.id,
    amount: rootStore.$state.calculatedPrice,
  });
};
